import { useState } from "react";
import { FiLock } from "react-icons/fi";
import { Button } from "newui/components/Button";
import { useCurrentUser } from "hooks/auth";
import { ChangePasswordModal } from "./ChangePasswordModal";

/**
 * PRO-731 — the "Change Password" entry point on My Profile. Renders just the
 * trigger button; the form itself now lives in a modal (ChangePasswordModal)
 * rather than expanding inline.
 */
export const ChangePasswordTrigger = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { currentUser } = useCurrentUser() || {};

	if (!currentUser) {
		return null;
	}

	return (
		<>
			<Button
				type="button"
				btntype="secondary"
				className="flex items-center gap-2"
				onClick={() => setIsOpen(true)}
				data-testid="change-password-trigger"
			>
				<FiLock />
				Change Password
			</Button>
			<ChangePasswordModal
				isOpen={isOpen}
				userId={currentUser.id}
				onClose={() => setIsOpen(false)}
			/>
		</>
	);
};
